/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminOrderStatusType,
    AdminOrderStatusTypeFromJSON,
    AdminOrderStatusTypeFromJSONTyped,
    AdminOrderStatusTypeToJSON,
} from './AdminOrderStatusType';

/**
 * 
 * @export
 * @interface AdminOrderStatus
 */
export interface AdminOrderStatus {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderStatus
     */
    createdAt: string;
    /**
     * 
     * @type {AdminOrderStatusType}
     * @memberof AdminOrderStatus
     */
    status: AdminOrderStatusType;
}



export function AdminOrderStatusFromJSON(json: any): AdminOrderStatus {
    return AdminOrderStatusFromJSONTyped(json, false);
}

export function AdminOrderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOrderStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'status': AdminOrderStatusTypeFromJSON(json['status']),
    };
}

export function AdminOrderStatusToJSON(value?: AdminOrderStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'status': AdminOrderStatusTypeToJSON(value.status),
    };
}

